import { useNavigate } from 'react-router-dom';
import { Building2, Users, CreditCard, Settings, RefreshCw, LogOut, Plus, Wallet } from 'lucide-react';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const username = localStorage.getItem('konemed_admin_username');

  const handleLogout = () => {
    localStorage.removeItem('konemed_admin_token');
    localStorage.removeItem('konemed_admin_username');
    navigate('/admin/login');
  };

  const menuItems = [
    {
      title: 'Crear Empresa',
      description: 'Registrar nueva clínica en el sistema',
      icon: Plus,
      path: '/admin/crear-empresa',
      color: 'emerald',
      testId: 'menu-crear-empresa'
    },
    {
      title: 'Ver Todas las Empresas',
      description: 'Listado completo de clínicas registradas',
      icon: Building2,
      path: '/admin/empresas',
      color: 'blue',
      testId: 'menu-empresas'
    },
    {
      title: 'Administrar Membresías',
      description: 'Gestionar membresías activas y pagos',
      icon: CreditCard,
      path: '/admin/memberships',
      color: 'violet',
      testId: 'menu-memberships'
    },
    {
      title: 'Renovaciones de Membresías',
      description: 'Próximas renovaciones y pagos pendientes',
      icon: RefreshCw,
      path: '/admin/renewals',
      color: 'amber',
      testId: 'menu-renewals'
    },
    {
      title: 'Configuración de Membresía',
      description: 'Editar tipos y precios de membresías',
      icon: Settings,
      path: '/admin/membership-config',
      color: 'slate',
      testId: 'menu-config'
    },
    {
      title: 'Medios de Pago',
      description: 'Configurar pasarelas de pago y ver transacciones',
      icon: Wallet,
      path: '/admin/medios-pago',
      color: 'orange',
      testId: 'menu-medios-pago'
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-dashboard">
      <header className="bg-white border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-indigo-600">
              Panel de Control Konemed
            </h1>
            <p className="text-slate-600 mt-1">Bienvenido, {username}</p>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="flex items-center gap-2 px-6 py-3 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg transition-colors font-semibold"
          >
            <LogOut size={20} />
            Cerrar Sesión
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-8 py-12">
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Administración del Sistema</h2>
          <p className="text-slate-600">Selecciona una opción para continuar</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                data-testid={item.testId}
                className={`bg-white rounded-xl p-8 border-2 border-slate-200 hover:border-${item.color}-400 hover:shadow-xl transition-all text-left group`}
              >
                <div className={`w-16 h-16 bg-${item.color}-100 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`text-${item.color}-600`} size={32} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm">{item.description}</p>
              </button>
            );
          })}
        </div>

        <div className="mt-12 bg-gradient-to-br from-violet-600 to-indigo-700 rounded-2xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-3">Sistema de Membresías</h3>
          <p className="text-violet-100 mb-4">
            Gestiona las clínicas, sus membresías activas, pagos y renovaciones desde este panel centralizado.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
            <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
              <p className="text-violet-200 text-sm">Demo</p>
              <p className="text-2xl font-bold">3</p>
              <p className="text-violet-200 text-xs">consentimientos</p>
            </div>
            <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
              <p className="text-violet-200 text-sm">Básico</p>
              <p className="text-2xl font-bold">30</p>
              <p className="text-violet-200 text-xs">consentimientos</p>
            </div>
            <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
              <p className="text-violet-200 text-sm">Rocket</p>
              <p className="text-2xl font-bold">50</p>
              <p className="text-violet-200 text-xs">consentimientos</p>
            </div>
            <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
              <p className="text-violet-200 text-sm">Groot</p>
              <p className="text-2xl font-bold">∞</p>
              <p className="text-violet-200 text-xs">ilimitado</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
